import React from 'react';
import possibilityImage from '../../assets/possibility.png';
import './possibility.css';

const Possibility = () => (
  <div className="gpt3__possibility section__padding" id="possibility">
    <div className="gpt3__possibility-image">
      <img src={possibilityImage} alt="possibility" />
    </div>
    <div className="gpt3__possibility-content">
      <h4>Open AI</h4>
      <h1 className="gradient__text">The possibilities are <br /> beyond your imagination</h1>
      <p> Open AI is an artificial intelligence research laboratory founded in December 2015 by Elon Musk, Sam Altman, Greg Brockman, Ilya Sutskever, and Wojciech Zaremba. The company's mission is to develop artificial general intelligence (AGI) in a way that is safe and beneficial to humanity. Open AI focuses on developing technologies that can be used to solve real-world problems and create new opportunities for people. Open AI has developed a number of open source tools and libraries for machine learning, including TensorFlow, PyTorch, and OpenAI Gym. The company also works on projects such as robotics, natural language processing, computer vision, reinforcement learning, and generative models.</p>
    </div>
  </div>
);

export default Possibility;
